// import { getCookie } from "@/utils/story-access";
import { MetypeCommentingWidget } from "@metype/components";
import React, { useEffect, useState } from "react";
import { CommentsEvent } from "../../../utils/gtm";
import { useSelector } from "react-redux";
import get from "lodash/get";

const Comments = ({ url, account_id }) => {
  const [show, setShow] = useState(false);
  const [token, setToken] = useState(null);

  const getState = useSelector((state) => state);
  const user = get(getState, ["firebaseUser"], null);
  const userNameGenerator = (email) => {
    let name = email.split("@")[0];
    return name;
  };
  const getAndSetJwt = async (userData) => {
    try {
      const token = await fetch("/gen-jwt", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });
      const data = await token.json();

      if (data.token) {
        localStorage.setItem("metypeToken", data.token);
        return data.token;
      } else {
        throw new Error("Error while generating token for" + userData.email);
      }
    } catch (error) {
      console.error(`${error.message}`);
    }
  };

  useEffect(() => {
    const settingInitialToken = async () => {
      if (localStorage.getItem("metypeToken")) {
        setToken(localStorage.getItem("metypeToken"));
        return;
      } else {
        let email = userNameGenerator(user.email);
        let data = {
          name: user.displayName ? user.displayName : email,
          email: user.email,
          id: user.uid,
          "avatar-url": user.photoURL,
        };
        let myToken = await getAndSetJwt(data);
        setToken(myToken);
      }
    };
    user ? settingInitialToken() : setToken(null);
  }, [user]);

  const listenToLogin = (event) => {
    if (event.data.action === "metype_login") {
      window.location.href = `${window.location.origin}/signin`;
    }
  };

  useEffect(() => {
    window.addEventListener("message", listenToLogin, false);
    return () => {
      window.removeEventListener("message", listenToLogin);
    };
  }, []);

  const RenderCommentWidget = () => {
    if (show && (!user || token === null)) {
      return (
        <MetypeCommentingWidget
          host="https://www.metype.com"
          accountId={account_id}
          primaryColor="#CA4241"
          className="metype-comments-widget dark:bg-zinc-800"
          secondaryColor="#FCFCFC"
          fontColor="#3d3d3d"
          windowHeight="400px"
          windowWidth="400px"
        />
      );
    } else if (show && token !== null) {
      return (
        <MetypeCommentingWidget
          host="https://www.metype.com"
          accountId={account_id}
          primaryColor="#CA4241"
          className="metype-comments-widget dark:bg-zinc-800"
          secondaryColor="#FCFCFC"
          fontColor="#3d3d3d"
          windowHeight="400px"
          windowWidth="400px"
          jwt={token}
          pageURL={url}
        />
      );
    }
  };

  //   if (show && (token !== "" || token !== null)) {
  //     return (
  //       <MetypeCommentingWidget
  //         host="https://www.metype.com"
  //         accountId={account_id}
  //         primaryColor="#CA4241"
  //         className="metype-comments-widget dark:bg-zinc-800"
  //         secondaryColor="#FCFCFC"
  //         fontColor="#3d3d3d"
  //         windowHeight="400px"
  //         windowWidth="400px"
  //         jwt={token}
  //         pageURL={url}
  //       />
  //     );
  //   }

  //   if (show && token === "") {
  //     return (
  //       <MetypeCommentingWidget
  //         host="https://www.metype.com"
  //         accountId={account_id}
  //         primaryColor="#CA4241"
  //         className="metype-comments-widget dark:bg-zinc-800"
  //         secondaryColor="#FCFCFC"
  //         fontColor="#3d3d3d"
  //         windowHeight="400px"
  //         windowWidth="400px"
  //       />
  //     );
  //   }
  // };

  return (
    <div className="mt-6 flex flex-col gap-2 px-[24px] mobile:px-0">
      <div className="flex">
        <button
          onClick={() => {
            setShow(!show);
            !show && CommentsEvent();
          }}
          id="add_comment_btn"
          className="flex cursor-pointer items-center justify-center gap-2 rounded-sm border border-transparent bg-primary px-3 py-2 font-satoshi text-sm text-white transition-all focus:outline-none focus:ring-offset-2 dark:focus:ring-offset-gray-800"
          aria-label="add_comment_btn"
        >
          <p>Comments {show ? <span>&uarr;</span> : <span>&darr;</span>}</p>
          {/* <p className="flex h-[24px] w-[24px] items-center justify-center rounded-full bg-white text-primary">
            {numberOfComment}
          </p> */}
        </button>
      </div>
      {RenderCommentWidget()}
    </div>
  );
};

export default Comments;
